class BackToTop extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['trigger']
  }

  connectedCallback () {
    super.connectedCallback()

    this.isTicking = false
    this.lastKnownY = window.scrollY

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)

    this.updateEl()
  }

  setupListeners () {
    super.setupListeners()

    this.onScroll = this.onScroll.bind(this)

    window.addEventListener('scroll', this.onScroll, { passive: true })

    this.listeners.add(this.els.trigger.element, 'click', (event) => {
      event.preventDefault()

      window.scrollTo({ top: 0, behavior: 'smooth' })
    })
  }

  onScroll () {
    this.lastKnownY = window.scrollY

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.toggleVisibility()
  }

  toggleVisibility () {
    this.setAttribute('aria-hidden', this.lastKnownY < 500)
  }
}

if (!window.customElements.get('back-to-top')) {
  window.customElements.define('back-to-top', BackToTop)
}
